var map = {
	"./esports-bg.webp": 1634,
	"./esports-ctg.webp": 1635,
	"./im-img.webp": 1636,
	"./im-title-cn.webp": 1637,
	"./im-title-en.webp": 1638,
	"./imone-img.webp": 1639,
	"./imone-title-cn.webp": 1640,
	"./imone-title-en.webp": 1641,
	"./object-1.webp": 1642,
	"./object-2.webp": 1643,
	"./object-3.webp": 1644,
	"./object-4.webp": 1645,
	"./tfg-img.webp": 1646,
	"./tfg-title-cn.webp": 1647,
	"./tfg-title-en.webp": 1648,
	"./title-cn.webp": 1649,
	"./title-en.webp": 1650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1633;